module.exports = __webpack_public_path__ + "media/theme/tutorial__itunes_2019--9--b-1e25549e.png";